import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { VendorState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/vendor";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { memo, useMemo, useState } from "react";

export const VendorDetails = memo(function VendorDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<VendorState>) {
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () => state.map((tag) => ({ text: tag, color: "gray" as const })),
    [state],
  );

  return (
    <RedoTagInputField
      delimiters={["newline"]}
      description="Vendors to limit the condition to. If no vendors are selected, the condition will apply to all vendors."
      inputValue={inputValue}
      label="Vendors"
      placeholder="Type and press Enter to add"
      setInputValue={setInputValue}
      setTags={setState}
      size="sm"
      state={disabled ? "disabled" : "default"}
      tags={tags}
    />
  );
});
